export const SET_ZIP_FILE = "SET_ZIP_FILE";
export const SET_XLSX_FILE = "SET_XLSX_FILE";
export const SET_CSV_FILE = "SET_CSV_FILE";
export const SET_ZIP_MESSAGE = "SET_ZIP_MESSAGE";
export const SET_XLSX_MESSAGE = "SET_XLSX_MESSAGE";
export const SET_CSV_MESSAGE = "SET_CSV_MESSAGE";
export const RESET_ZIP_FILE = "RESET_ZIP_FILE";
export const RESET_XLSX_FILE = "RESET_XLSX_FILE";
export const RESET_CSV_FILE = "RESET_CSV_FILE";

export const SetZipFile = (file: File | undefined) => {
    return { type: SET_ZIP_FILE, file };
};
export const SetXlsxFile = (file: File | undefined) => {
    return { type: SET_XLSX_FILE, file };
};
export const SetCsvFile = (file: File | undefined) => {
    return { type: SET_CSV_FILE, file };
};
export const SetZipMessage = (msg: string) => {
    return { type: SET_ZIP_MESSAGE, msg };
};
export const SetXlsxMessage = (msg: string) => {
    return { type: SET_XLSX_MESSAGE, msg };
};
export const SetCsvMessage = (msg: string) => {
    return { type: SET_CSV_MESSAGE, msg };
};
export const ResetZipFile = () => {
    return { type: RESET_ZIP_FILE };
};
export const ResetXlsxFile = () => {
    return { type: RESET_XLSX_FILE };
};
export const ResetCsvFile = () => {
    return { type: RESET_CSV_FILE };
};
